// Central gate + IDs for the analytics loaders.
//
// CRA inlines REACT_APP_* vars at BUILD time, and NODE_ENV is "production" for
// both staging and prod builds, so it can't tell them apart. The reliable
// signal is the runtime hostname. Amplify forces env vars onto every branch,
// so we additionally gate on the production host: staging carries the vars but
// never actually loads the scripts.
//
// Set REACT_APP_ANALYTICS_DEBUG=true in a local .env to flip analytics on at
// localhost for verification (see Network tab / GA4 DebugView).
const PRODUCTION_HOST = 'app.puredesire.org';

export const analyticsEnabled =
  (typeof window !== 'undefined' && window.location.hostname === PRODUCTION_HOST) ||
  process.env.REACT_APP_ANALYTICS_DEBUG === 'true';

export const GA_ID = process.env.REACT_APP_GA_ID;
export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
export const TAPFILIATE_ACCOUNT_ID = process.env.REACT_APP_TAPFILIATE_ACCOUNT_ID;
